module.exports = __webpack_public_path__ + "static/tipsAndTricksFront-2de28f4e4e9874bb6d6dd6374df4129b.png";